import styled, { css } from 'styled-components';
import layoutStyles from 'admin-components/styles/layout';
import StrippedBackElement from 'admin-components/utils/strippedBackElement';

export const FieldLabel = styled(StrippedBackElement)`
  display: flex;

  text-transform: uppercase;

  ${({ type }) => {
    if (type === 'checkbox') {
      return css`
        flex-direction: row;
        align-items: center;
      `;
    }

    if (type === 'radio') {
      return css`
        width: auto !important;
        flex-direction: row-reverse;
        justify-content: flex-end;
        align-items: center;
      `;
    }

    return css`
      flex-direction: column;
      align-items: flex-start;
    `;
  }} ${layoutStyles};
`;
